import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductactivationlistComponent } from './productactivationlist/productactivationlist.component';
import { ProductactivationlistnewComponent } from './productactivationlistnew/productactivationlistnew.component';
import { DeleteacticationComponent } from './deleteactication/deleteactication.component';


const routes: Routes = [

  {
    path: '' ,redirectTo:'Productactivationlist',pathMatch:'full'
  },
  {
    path:'Productactivationlist',component:ProductactivationlistComponent,
  },
  {
    path:'ProductactivationlistNew',component:ProductactivationlistnewComponent,
  },
  {
    path:'DeleteActivation',component:DeleteacticationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
